import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { catalogBibShape, ugcQuotationShape, libraryShape } from '@bibliocommons/bc-prop-types';
import Divider from 'app/components/bibs/shared/Divider';
import QuotationDisplayContainer from 'app/components/bibs/shared/ugc/QuotationDisplay';
import CommunityDisclaimer from 'app/components/bibs/shared/ugc/CommunityDisclaimer';
import BibSubPage from 'app/components/bibs/subpages/BibSubPage';

import './QuotationPage.scss';

export class QuotationPage extends React.PureComponent {
  componentDidMount() {
    this.fetchRelationships();
  }

  fetchRelationships() {
    const { currentUserId, quotation, relationshipsActions } = this.props;
    const authorUserId = quotation.get('userId', null);

    if (currentUserId && authorUserId) {
      relationshipsActions.getRelationships({ userId: currentUserId, userIds: Immutable.List([authorUserId]) });
    }
  }

  renderUgcDisclaimer() {
    const { currentLibrary } = this.props;
    return (
      currentLibrary?.get('ugcDisclaimerMessageEnabled') && (
        <CommunityDisclaimer type="quotations" currentLibrary={currentLibrary} />
      )
    );
  }

  render() {
    const { quotation, catalogBib } = this.props;

    return (
      <div className="cp-quotation-page">
        <BibSubPage catalogBib={catalogBib} headerLocKey="quotation">
          <Divider />
          {this.renderUgcDisclaimer()}
          <QuotationDisplayContainer
            quotation={quotation}
            key={quotation.get('id')}
            displayStaffBadge={false}
            catalogBib={catalogBib}
          >
            {quotation.get('quotation')}
          </QuotationDisplayContainer>
        </BibSubPage>
      </div>
    );
  }
}

QuotationPage.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  currentUserId: PropTypes.number,
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotation: ugcQuotationShape.isRequired,
  currentLibrary: libraryShape.isRequired
};

export default QuotationPage;
